import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import ButtonLink from 'components/button/link';
import StorefrontThemeStyles from './theme-styles';

import './storefront.scss';

export default class StorefrontListItemCard extends React.PureComponent {
  static propTypes = {
    image: PropTypes.any,
    title: PropTypes.any.isRequired,
    headerIcon: PropTypes.any,
    subtitle: PropTypes.any,
    description: PropTypes.string,
    tags: PropTypes.array,
    useCases: PropTypes.any,
    theme: PropTypes.object,
    action: PropTypes.node,
    actionLabel: PropTypes.string,
    actionLink: PropTypes.string,
    onClickAction: PropTypes.func,
    isActionCard: PropTypes.bool,
    onChangeThemeStyle: PropTypes.func,
  };

  renderItemCard() {
    const {
      image,
      headerIcon,
      title,
      titleExtra,
      subtitle,
      tags,
      useCases,
      theme,
      action,
      actionLabel,
      actionLink,
      onClickAction,
      onChangeThemeStyle,
    } = this.props;

    const hasAction = Boolean(action || actionLabel);

    return (
      <div className="storefront-apps-item">
        {image ? (
          <div className="storefront-apps-image">{image}</div>
        ) : headerIcon ? (
          <div className="storefront-apps-image-icon">{headerIcon}</div>
        ) : null}
        <div className="storefront-apps-details">
          <div className="storefront-apps-details-content">
            <div className="storefront-apps-details-header">
              <div className="storefront-apps-title">{title}</div>
              {titleExtra && (
                <div className="storefront-apps-extra">{titleExtra}</div>
              )}
            </div>
            {subtitle && (
              <div className="storefront-apps-subtitle">{subtitle}</div>
            )}
          </div>
          {hasAction && (
            <div className="storefront-apps-actions">
              {action ? (
                action
              ) : onClickAction ? (
                <Button type="secondary" size="md" onClick={onClickAction}>
                  {actionLabel}
                </Button>
              ) : (
                actionLabel && (
                  <ButtonLink type="secondary" size="md" href={actionLink}>
                    {actionLabel}
                  </ButtonLink>
                )
              )}
            </div>
          )}
          {tags?.length > 0 && (
            <div className="storefront-apps-tags">
              <ul className="view-body-tags">
                {tags.map((tag, i) => (
                  <li key={i} className="nowrap">
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {useCases}
          <StorefrontThemeStyles
            theme={theme}
            onChangeStyle={onChangeThemeStyle}
          />
        </div>
      </div>
    );
  }

  render() {
    const { isActionCard } = this.props;

    return isActionCard ? (
      <div className="storefront-apps-action-card">{this.renderItemCard()}</div>
    ) : (
      this.renderItemCard()
    );
  }
}
